<template>
  <div>
    <textarea :class="customClass" :maxlength="maxlength" :id="fieldId" :placeholder="placeholder" v-model="description"></textarea>
  </div>
</template>

<script>
export default {
  props: {
    fieldId: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    customClass:{
      type:String,
      default:''
    },
    maxlength:{
      type:String,
      default:''
    }
  },
  data() {
    return {
      description: this.value,
    };
  },
  watch: {
    description() {
      this.$emit('input', this.description);
    },
  },
};
</script>
